import { action as apiAction } from 'api/Api'
import {
  setDueDate,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  dueDate: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, dueDate } = payload

  const optimisticAction = optimisticDispatch(dispatch, setDueDate({
    id: cardId,
    dueDate
  }))

  try {
    await apiAction('SetDueDate', {
      timestamp: dueDate,
      cardId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
